import Box from '@mui/material/Box'
import {IConceptFE} from 'interfaces/IConceptFE'
import {ISavedSearchFE} from 'interfaces/ISavedSearchFE'
import * as React from 'react'
import {DragDropContext, Droppable, OnDragEndResponder} from 'react-beautiful-dnd'
import DraggableConceptItemNotify from './DraggableConceptItemNotify'

export type DraggableListProps = {
  search: ISavedSearchFE
  items: IConceptFE[]
  onDragEnd: OnDragEndResponder
  stackVertical?: boolean
  chipSize?: 'sm' | 'md' | 'lg' | undefined
  disabledText?: string
}

const DraggableConceptNotify = React.memo(
  ({search, items, onDragEnd, stackVertical, chipSize, disabledText}: DraggableListProps) => {
    return (
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable
          droppableId='droppable-list'
          direction={stackVertical ? 'vertical' : 'horizontal'}
        >
          {(provided: any) => (
            <Box
              display={'flex'}
              flexDirection={stackVertical ? 'column' : 'row'}
              flexWrap={'wrap'}
              ref={provided.innerRef}
              {...provided.droppableProps}
            >
              {items.map((item, index) => (
                <DraggableConceptItemNotify
                  disabledText={disabledText}
                  search={search}
                  item={item}
                  index={index}
                  key={item.name}
                  size={chipSize}
                />
              ))}
              {provided.placeholder}
            </Box>
          )}
        </Droppable>
      </DragDropContext>
    )
  }
)

export default DraggableConceptNotify
